"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VTabPanel = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@blueprintjs/core");
var style_1 = require("../../TabsMenu/style");
var style_2 = require("../style");
var Badge_1 = require("../../Badge");
var styled_components_1 = __importDefault(require("styled-components"));
var VTabPanel = (function (_super) {
    __extends(VTabPanel, _super);
    function VTabPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnClick = function (e) {
            _this.props.handleOnClick(_this.props.id);
        };
        return _this;
    }
    VTabPanel.prototype.render = function () {
        var _a = this.props, size = _a.size, label = _a.label, icon = _a.icon, active = _a.active, borderColor = _a.borderColor, activeColor = _a.activeColor, activeTextColor = _a.activeTextColor, activeBackgroundColor = _a.activeBackgroundColor, textColor = _a.textColor, backgroundColorBadge = _a.backgroundColorBadge, dataBadge = _a.dataBadge, textColorBadge = _a.textColorBadge, activeBorderColor = _a.activeBorderColor, backgroundColor = _a.backgroundColor;
        return (react_1.default.createElement(style_2.LabelIcon, { className: "".concat(active && 'active', " gsi-tab-panel-item"), borderColor: borderColor, activeColor: activeColor, backgroundColor: backgroundColor, activeTextColor: activeTextColor, activeBackgroundColor: activeBackgroundColor, textColor: textColor, active: active, onClick: this.handleOnClick, activeBorderColor: activeBorderColor, size: size, padding: this.props.padding },
            icon && typeof icon === 'object' && (react_1.default.createElement(core_1.Icon, __assign({ style: style_1.labelIcon }, icon))),
            icon && react_1.default.isValidElement(icon) && react_1.default.createElement(react_1.default.Fragment, null, icon),
            react_1.default.createElement(StyledSpan, null, label),
            dataBadge && (react_1.default.createElement(Badge_1.VBadge, { backgroundColorBadge: backgroundColorBadge, textColorBadge: textColorBadge, dataBadge: dataBadge }))));
    };
    return VTabPanel;
}(react_1.Component));
exports.VTabPanel = VTabPanel;
var StyledSpan = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"], ["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"])));
var templateObject_1;
